// extracted by mini-css-extract-plugin
module.exports = {"root":"BackgroundImage_root__j4K6d","content-wrap":"BackgroundImage_content-wrap__QsduK"};